import { Base } from './base.model';

export class SiteStatus extends Base {
  public name: string;
  public category: string;
}
